import React from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import { styled } from 'styled-components'; // ou @mui/material/styles
import { cores, coresGrafico } from '../../../../styles/styleUtils';

// Cores baseadas na paleta de gráfico oficial
const colors = coresGrafico.slice(0, 3);

// Gerador de cor aleatória simples
const getRandomColor = (id) => {
  const index = (id.charCodeAt(id.length - 1) || 0) % colors.length;
  return colors[index];
};

const CardWrapper = styled(Paper)`
  padding: 16px;
  border-radius: 12px;
  background-color: ${cores.branco};
  border-left: 4px solid ${(props) => props.bgColor};
  color: ${cores.chumbo}; // Cor do texto escura para contraste
`;

const DetailText = styled(Typography)`
  font-weight: 500;
  font-size: 0.9rem;
`;

// Função para formatar moeda
const formatCurrency = (value) => {
  return (value || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

// Função para formatar data
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
};

function AgendaCard({ os }) {
  // Pega uma cor com base no ID da OS
  const cardColor = getRandomColor(os._id);

  return (
    <CardWrapper elevation={3} bgColor={cardColor}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <DetailText>
            <strong>CLIENTE:</strong> {os.idCliente?.nome || 'N/A'}
          </DetailText>
        </Grid>
        <Grid item xs={12} sm={6}>
          <DetailText>
            <strong>FABRICANTE:</strong> {os.idFornecedor?.nome || 'N/A'}
          </DetailText>
        </Grid>
        <Grid item xs={12} sm={6}>
          <DetailText>
            <strong>DATA DE ABERTURA:</strong> {formatDate(os.data)}
          </DetailText>
        </Grid>
        <Grid item xs={12} sm={6}>
          <DetailText>
            <strong>CLASSIFICAÇÃO:</strong> {os.idClassificacao?.nome || 'N/A'}
          </DetailText>
        </Grid>
        <Grid item xs={12} sm={6}>
          <DetailText>
            <strong>VALOR DO SERVIÇO:</strong> {formatCurrency(os.valorServico)}
          </DetailText>
        </Grid>
        <Grid item xs={12} sm={6}>
          <DetailText>
            <strong>RESPONSÁVEL:</strong> {os.idResponsavelExecucao?.nome || 'N/A'}
          </DetailText>
        </Grid>
      </Grid>
    </CardWrapper>
  );
}

export default AgendaCard;